import ImportExportIcon from '@material-ui/icons/Assignment';
//import AssignmentIcon from '@mui/icons-material/Assignment';
import ShipmentList from './ShipmentList';
import uploadCreate from './UploadCreate'

export default {
    list: ShipmentList,
    create: uploadCreate,
    icon: ImportExportIcon,
};
